import type { CpgLciReportsFieldsData } from '../utils/build-presentation';
import type { MinimalCpgDimension } from '../slides/dimension-slide';

type OverallRetailer = MinimalCpgDimension & {
  name: 'Overall';
};

export const buildOverallRetailer = (
  report: CpgLciReportsFieldsData['report']
): OverallRetailer => ({
  ...report,
  dimensionValue: 'Overall',
  salesLiftIndex: 1,
  name: 'Overall',
  salesRate: report.totalSalesRate ?? null,
});
